import React from 'react';

import useClubRecognitionProgramLevel from './UseClubRecognitionProgramLevel';

import WorkFlowNavigation from '../components/navigation/WorkFlowNavigation';

import ProgramCategoryGrid from '@usas/ui-web/components/grids/programCategory/ProgramCategoryGrid';
import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';
import LeftArrowIcon from '@usas/ui-web/components/icons/LeftArrowIcon';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const ClubRecognitionProgramLevel = () => {
  const {
    location,
    Constants,
    programLevelState,
    state,
    onEdit,
    onBackClicked,
    onCertifyLevelClicked
  } = useClubRecognitionProgramLevel();

  return (
    <div className="row">
      <WorkFlowNavigation headerTitle={programLevelState.objData !== undefined && programLevelState.objData?.levelName ?
        'Club Recognition Program - ' + programLevelState.objData?.levelName + `${location.state?.isRevisit === true ? ' - Revisit' : ' - New Request'}` : 'Club Recognition Program' + `${location.state?.isRevisit === true ? ' - Revisit' : ' - New Request'}`}>
        <div className="row">
          <div className="col-xs-12">
            <button className={global.BackToSearchButton}
              type="button"
              onClick={onBackClicked}>
              <LeftArrowIcon /> {`Back to Club Recognition Program Queue${location.state?.isRevisit === true ? ' - Requires Revisit' : ' - New Requests'}`}
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12" style={{ fontSize: '18px' }}>
            <p><b>LSC Code/Club Code:</b> {state.qualifiedOrgUnitCode}</p>
            <p><b>Club Name:</b> {state.clubName}</p>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <hr className={[global.ThinBar, 'usas-bar-gray'].join(' ')} />
          </div>
        </div>
        {location.state?.isRevisit === false &&
          <div className="row">
            <div className="col-xs-12">
              <ActionIntraPageButton type="button" onClick={onCertifyLevelClicked}>Certify Level</ActionIntraPageButton>
            </div>
          </div>}
        <div className="row usas-extra-top-margin usas-extra-bottom-margin">
          <div className="col-xs-12">
            <ProgramCategoryGrid
              state={programLevelState}
              onEdit={onEdit} />
          </div>
        </div>
        <PopUpModal
          widthPct={50}
          maxWidth={250}
          title={Constants.LOADING_MSG}
          displayPopUp={programLevelState.isObjLoading} />
      </WorkFlowNavigation>
    </div>
  );
};

export default ClubRecognitionProgramLevel;